package org.hs_soft.runmynesto.data.api_datasource.home

import org.hs_soft.runmynesto.data.local_datasource.local_storage.getFromLocalStorage
import org.hs_soft.runmynesto.domain.model.home.options.LanguageEnum
import org.hs_soft.runmynesto.domain.repository.local_datasource.home.GetLanguageRepository
import org.hs_soft.runmynesto.domain.util.IdUtils
import org.hs_soft.runmynesto.domain.config.Errors

class GetLanguageRepositoryImpl:GetLanguageRepository {
    override suspend fun getLanguage(): String {
        return getFromLocalStorage(IdUtils.language)
            ?:LanguageEnum.German.displayName
    }
}